import React from "react";
import { useSelector } from "react-redux";

import { LoadingTopBar } from "~/components/UI/LoadingTopBar";
import Documents from "~/containers/Documents";
import Layout from "../components/UI/Layout/Layout";

// The list is loaded by the container, using the filters restored from the
// last visit (or the current month by default).
export const ScreensDocuments = () => {
  const isLoading = useSelector((state) => state.documents.isLoading);

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <Documents />
      </Layout>
    </div>
  );
};
